module.exports = __webpack_public_path__ + "img/PHorsemen64_ua.3a8583a7.webp";